{
  "LoadingLabel": "[Chargement...]",
  "NAME": "ComboBox"
}